import React from "react";

export default function dailyReport() {
  return (
    <>
    </>
  );
}
